"use strict";
module.exports = function (app) {
    app.factory('FrontEndService', ['$http', function ($http) {
        var promise =  $http({
              method: 'GET',
              url: window.location.origin + "/frontend.json"
              }).then(function onSuccess(res){
                  return res;
              }, function onErr(res)
              {
                  console.log(res);
              });

        return {
            url: function() {
                return promise;
            }
        };
    }]);
};


/*****************
 ** WEBPACK FOOTER
 ** ./shared/js/service/front_end.service.js
 ** module id = 81
 ** module chunks = 0
 **/